import HttpCliente from "../HttpCliente";

export const getNewsletterNormas = (token, fechaDesde, fechaHasta, filtrosOrganismoTipo = []) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post(`/Newsletter/Normas`, 
      {
        fechaDesde,
        fechaHasta,
        filtrosOrganismoTipo
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};